import {
  getServmeShifts
} from "./chunk-NCW3PHK5.mjs";
import {
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/hooks/wbk/restaurants/shifts.ts
import { useQuery } from "@tanstack/react-query";
var useServmeShifts = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["getServmeShifts", props],
    queryFn: () => getServmeShifts(props)
  }, options));
};

export {
  useServmeShifts
};
//# sourceMappingURL=chunk-YHCBYGKV.mjs.map